module.exports = __webpack_public_path__ + "static/img/Ben_Brown_desktop.eae1cab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben_Brown_desktop.jpg
// module id = YpzB
// module chunks = 0